module.exports = __webpack_public_path__ + "sc.svg?36964dc612396d77c345fd327821f20d";